import { UserEntity, UserEntityBase } from "./user-entity.model"


export class UserBase {

    id!: number
    name!: string
    identifier!: string
    userEntity: UserEntity = new UserEntityBase()

    static fromUser(user: User): UserBase {
        let current = new UserBase()
        Object.assign(current, user)

        current.userEntity = new UserEntityBase()
        if (user.userEntity == null) {
            return current
        }

        current.userEntity = UserEntityBase.fromUserEntity(user.userEntity)

        return current;
    }
}

export interface User extends UserBase {

}
